import React, { useEffect, useState, useRef } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaUser,
} from "react-icons/fa6";
import { MdDelete, MdClose } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { history } from "../../../../store/configure/configureStore";
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";
import moment from "moment";
import YouTube from "react-youtube";
// import queryString from "query-string";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  TagView,
  ModalView,
} from "../../../controls";
import { Role } from "../../../../constants/role";
//
import "./MobileUserDetailsStyles.scss";

const MobileUserDetailsView = ({ mobileUserDataById, onClickCancel }) => {
  //render personal details

  const {
    name,
    personMobilePhone,
    email,
    personMailingCity,
    personMailingState,
    personMailingCountry,
    photourl,
    userType,
    createdDate,
    status,
    isFreeMember,
    subscriptions,
    purchasedAndActiveSubscriptionsName,
    isAnySubscriptionAmountDue,
  } = mobileUserDataById || {};

  const renderDetailRow = (label, value) => (
    <div className="row-wrapper">
      <span className="label-wrapper">{label}</span>
      <span className="partition">:</span>
      <span className="value">{value || "N/A"}</span>
    </div>
  );

  const renderPersonalDetailsBlock = () => {
    return (
      <div className="personal-details-wrapper">
        <div className="title">Personal Details</div>
        <div className="wrapper">
          <div className="left-side-block">
            {renderDetailRow("Full Name", name || "N/A")}
            {renderDetailRow("Contact Number", personMobilePhone || "N/A")}
            {renderDetailRow("Email", email || "N/A")}
            {renderDetailRow("City", personMailingCity || "N/A")}
            {renderDetailRow("State", personMailingState || "N/A")}
            {renderDetailRow("Country", personMailingCountry || "N/A")}
          </div>
          <div className="right-side-block">
            <FaUser size={100} />
            {/* <img
              className="user-image"
              src={
                // photourl ||
                "https://as1.ftcdn.net/v2/jpg/03/46/83/96/1000_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"
              }
              alt="User Photo"
            /> */}
          </div>
        </div>
      </div>
    );
  };

  const renderAccountDetailsBlock = () => {
    return (
      <div className="account-details-wrapper">
        <div className="title">Account Details</div>
        <div className="wrapper">
          {renderDetailRow("User Type", userType || "N/A")}
          {renderDetailRow(
            "Account Created",
            moment(createdDate).format("MM-DD-YYYY") || "N/A"
          )}
          {renderDetailRow("Status", status || "N/A")}
          {renderDetailRow("Free Member", isFreeMember ? "Yes" : "No")}
        </div>
      </div>
    );
  };

  const renderCommaSeparatedSubscriptions = () => {
    return subscriptions
      ?.map(
        (sub) =>
          `${sub.name || ""}${
            sub.subscriptionOfferingName
              ? ", " + sub.subscriptionOfferingName
              : ""
          }`
      )
      .join(", ");
  };
  const renderSubscriptionDetailsBlock = () => {
    return (
      <div className="subscription-details-wrapper">
        <div className="title">Subscription Details</div>
        <div className="wrapper content">
          {renderDetailRow(
            "Subscription Type",
            subscriptions?.[0]?.subscriptionType || "N/A"
          )}
          {renderDetailRow(
            "Active Subscription",
            purchasedAndActiveSubscriptionsName || "N/A"
          )}
          {renderDetailRow(
            "SubScription Start Date",
            moment(subscriptions?.[0]?.subscriptionStartDate).format(
              "MM-DD-YYYY"
            ) || "N/A"
          )}
          {renderDetailRow(
            "Amount Due",
            isAnySubscriptionAmountDue ? "Yes" : "No" || "N/A"
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="mobile__user__details--container">
      <div className="mobile__user__details--header-wrapper">
        <div className="title-content">Mobile User Details</div>
        <div className="action-btn-wrapper">
          {/* {userPermissions?.includes("add_user") && ( */}
          <ButtonView
            title="Cancel"
            styles={"secondary"}
            // icon={<FaPlus />}
            onClick={onClickCancel}
          />
          {/* )} */}
        </div>
      </div>
      <div className="mobile__user__details--content-details-wrapper coming-soon">
        {/* <div className="details-block primary">
          {renderPersonalDetailsBlock()}
        </div>
        <div className="details-block secondary">
          {renderAccountDetailsBlock()}
        </div>
        <div className="details-block subscription">
          {renderSubscriptionDetailsBlock()}
        </div> */}
        Coming soon
      </div>
    </div>
  );
};

export default MobileUserDetailsView;
